module.exports = __webpack_public_path__ + "static/img/5.f03d083.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/zh/5.png
// module id = JinD
// module chunks = 0